import React, { useEffect, useState } from 'react';
import ApiClient from '../../helpers/ApiClient';
import { toast } from 'react-hot-toast';
import { IconPlus, IconTrash } from '@tabler/icons-react';
import Page from "../../components/Page";

export default function PurchaseUnitsPage() {
  const [units, setUnits] = useState([]);
  const [name, setName] = useState('');
  const [symbol, setSymbol] = useState('');
  const [unitType, setUnitType] = useState('COUNT');

  const fetchUnits = async () => {
    try {
      const res = await ApiClient.get('/settings/purchase-units');
      setUnits(res.data);
    } catch (error) {
      toast.error('Failed to load purchase units');
    }
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  const handleCreate = async () => {
    if (!name || !symbol) return toast.error('Name and Symbol required');
    try {
      await axios.post('/api/settings/purchase-units', { name, symbol, unit_type: unitType });
      toast.success('Purchase unit created');
      setName('');
      setSymbol('');
      fetchUnits();
      document.getElementById('modal-add-unit').close();
    } catch (error) {
      toast.error('Failed to create purchase unit');
    }
  };

  return (
    <Page className="px-4 py-4 md:px-8 md:py-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="text-2xl font-bold">Purchase Units</h3>
          <p className="text-gray-500 text-sm">Define bulk units (Box, Tray, Carton) used when purchasing inventory.</p>
        </div>
        <button className="btn btn-primary btn-sm flex items-center gap-1" onClick={() => document.getElementById('modal-add-unit').showModal()}>
          <IconPlus size={18} /> Add Unit
        </button>
      </div>

      <div className="bg-white dark:bg-restro-gray border border-restro-border-green rounded-2xl overflow-hidden">
        <table className="table w-full">
          <thead>
            <tr className="bg-restro-bg-gray">
              <th>Name</th>
              <th>Symbol</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {units.map((u) => (
              <tr key={u.id}>
                <td>{u.name}</td>
                <td>{u.symbol}</td>
                <td>{u.unit_type}</td>
                <td>
                  <button onClick={() => handleDelete(u.id)} className="btn btn-error btn-sm btn-square btn-ghost text-red-500">
                    <IconTrash size={18} />
                  </button>
                </td>
              </tr>
            ))}
            {units.length === 0 && (
              <tr><td colSpan="4" className="text-center py-4 text-gray-500">No purchase units defined.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <dialog id="modal-add-unit" className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg mb-4">Add Purchase Unit</h3>
          <div className="form-control mb-4">
            <label className="label"><span className="label-text">Name (e.g. Carton, Box)</span></label>
            <input type="text" className="input input-bordered w-full" value={name} onChange={e => setName(e.target.value)} />
          </div>
          <div className="form-control mb-4">
            <label className="label"><span className="label-text">Symbol (e.g. CTN, BX)</span></label>
            <input type="text" className="input input-bordered w-full" value={symbol} onChange={e => setSymbol(e.target.value)} />
          </div>
          <div className="form-control mb-4">
            <label className="label"><span className="label-text">Type</span></label>
            <select className="select select-bordered w-full" value={unitType} onChange={e => setUnitType(e.target.value)}>
              <option value="COUNT">Count (Packets, Boxes, Cartons)</option>
              <option value="WEIGHT">Weight (Sacks, Bags)</option>
              <option value="VOLUME">Volume (Bottles, Barrels)</option>
            </select>
          </div>
          <div className="modal-action">
            <form method="dialog">
              <button className="btn btn-ghost mr-2">Cancel</button>
              <button className="btn btn-primary" onClick={(e) => { e.preventDefault(); handleCreate(); }}>Save</button>
            </form>
          </div>
        </div>
      </dialog>
    </Page>
  );
}
